var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRefresh = function SvgRefresh(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "#fff"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.944 12.979C20.455 17.488 16.638 21 12 21a8.97 8.97 0 0 1-6.763-3.075l1.245-1.633A6.99 6.99 0 0 0 12 19c3.526 0 6.444-2.624 6.923-6.021H16l4-5.25 4 5.25zM5.08 11c.487-3.387 3.4-6 6.92-6a6.98 6.98 0 0 1 5.51 2.698l1.244-1.632A8.97 8.97 0 0 0 12 3c-4.632 0-8.443 3.501-8.941 8H0l4 5.25L8 11z"
  })));
};
export default SvgRefresh;